import { Node, mergeAttributes } from "@tiptap/core";

// A custom atomic node so editors can insert a styled call-to-action button,
// which none of TipTap's built-in nodes cover. Renders as <a class="cms-btn">
// on both sides (editor view and getHTML() output) so the sanitizer allowlist
// (backend utils/sanitizeBlogHtml.js) and the website's .cms-btn CSS both
// recognize it without any extra parsing step.
const ButtonNode = Node.create({
  name: "ctaButton",
  group: "inline",
  inline: true,
  atom: true,

  addAttributes() {
    return {
      href: { default: "" },
      label: { default: "Button" },
    };
  },

  parseHTML() {
    return [{ tag: "a.cms-btn" }];
  },

  renderHTML({ HTMLAttributes, node }) {
    return [
      "a",
      mergeAttributes(HTMLAttributes, {
        class: "cms-btn",
        href: node.attrs.href,
        target: "_blank",
      }),
      node.attrs.label,
    ];
  },

  addNodeView() {
    return ({ node }) => {
      const dom = document.createElement("a");
      dom.className = "cms-btn";
      dom.href = node.attrs.href;
      dom.target = "_blank";
      dom.rel = "noopener noreferrer";
      dom.contentEditable = "false";
      dom.textContent = node.attrs.label || "Button";
      return { dom };
    };
  },
});

export default ButtonNode;
